import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/options/page.tsx");
